import { render, staticRenderFns } from "./NavigationBack.vue?vue&type=template&id=60a1bbe6&scoped=true"
import script from "./NavigationBack.vue?vue&type=script&lang=js"
export * from "./NavigationBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a1bbe6",
  null
  
)

export default component.exports